import React, { useEffect, useState } from "react"
import { InputTypeText, InputTypeArea } from '../../elements'
import { Form } from 'informed'
import { deleteSQLReportData, getSQLReportDetail, updateSQLReportData } from "../../services/reports_services"
import { toast } from "react-toastify"
const SQLReportDetailPage = ( { match, history } ) => {

    const formApiRef = React.useRef()
    const [formValues, setFormValues] = useState( null )

    const { id } = match.params

    const getData = async () => {
        const res = await getSQLReportDetail( id )
        formApiRef.current.setValues( {
            ...res
        } )
        delete res.id
        setFormValues( res )

    }

    const handleSubmit = () => {
        updateSQLReportData( id, formValues ).then( () => {
            history.push( '/reports/sql' )
            window.location.reload()
            toast.success( 'Relatório editado com sucesso.' )
        } )
    }
    const handleDelete = () => {
        deleteSQLReportData( id ).then( () => {
            history.push( '/reports/sql' )
            window.location.reload()
            toast.success( 'Relatório excluido com sucesso.' )
        } )
    }

    useEffect( () => {
        if ( id && formApiRef.current ) {
            getData()
        }
    }, [] )

    return (
        <div className="p-3 d-flex flex-column justify-center align-center">
            <div className="d-flex align-center">
                <h4>Criar Relatório SQL</h4>
            </div>
            <div style={gridStyle}>
                <Form getApi={( api ) => ( formApiRef.current = api )} // Referência para o formApi
                    className="w-100" onValueChange={v => setFormValues( v )}>
                    <InputTypeText col="12" field="name" label="Nome do Relatório" />
                    <InputTypeArea style={{ minHeight: '80px', }} field="sql" label="SQL" col="12" />
                    <div style={{ gap: '20px' }} className="w-100 text-right d-flex flex-row justify-space-between">
                        <button
                            className="btn btn-danger"
                            type="submit"
                            onClick={() => handleDelete()}
                        >
                            Excluir
                        </button>
                        <button
                            className="btn btn-primary"
                            type="submit"
                            onClick={() => handleSubmit()}
                        >
                            Salvar
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default SQLReportDetailPage

const gridStyle = {
    display: "flex",
    width: "100%",
    gap: "10px",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "10px",
}

const buttonStyle = {
    border: "none",
    width: "50%",
    height: "30px",
    cursor: "pointer",
    color: "#ffff",
    borderRadius: "5px",
    backgroundColor: "#499d96",
    textAlign: "center",
    outline: "none",
}
